import React from 'react';
import DatePicker from 'react-datepicker';

import { Props } from '@/ui/components/Form/DatetimePicker/types';
import Label from '@/ui/components/Form/Label';
import { dateFromDateStringWithAppendedTime } from '@/utils/dates';

import 'react-datepicker/dist/react-datepicker.css';

/**
 * @deprecated Do not use this component. Use the base components at the root of the UI folder instead.
 */
const DatetimePicker = ({
  autoFocus = false,
  dateFormat = 'MMMM d, yyyy h:mm aa',
  disabled = false,
  label,
  helpText,
  isClearable = true,
  minDate,
  name,
  onBlur,
  onChange,
  placeholder = '--/--/---- --:--',
  placement = 'bottom-start',
  preventOpenOnFocus = false,
  showTimeSelect = true,
  value,
  withPortal = false
}: Props) => {
  // Prevent datepicker from setting incorrect date due to user timezone offset less than UTC
  const dateValue = value ? dateFromDateStringWithAppendedTime(value) : null;
  const labelId = `datepicker-${name}`;

  return (
    <>
      <Label htmlFor={labelId} text={label}></Label>
      {helpText && <p className="text-sm text-gray-600">{helpText}</p>}

      <DatePicker
        autoFocus={autoFocus}
        className={`flex items-center mt-1 text-left w-full border border-gray-300 bg-white rounded-md shadow-xs focus:outline-hidden focus:ring-indigo-500 focus:border-indigo-500 text-base ${
          disabled ? 'opacity-50' : ''
        }`}
        dateFormat={dateFormat}
        disabled={disabled}
        id={labelId}
        isClearable={isClearable}
        minDate={minDate}
        name={name}
        onBlur={onBlur}
        onChange={onChange}
        placeholderText={placeholder}
        popperClassName="w-max"
        popperPlacement={placement}
        preventOpenOnFocus={preventOpenOnFocus}
        scrollableYearDropdown
        selected={dateValue}
        shouldCloseOnSelect
        showIcon
        showTimeSelect={showTimeSelect}
        showYearDropdown
        withPortal={withPortal}
        yearDropdownItemNumber={30}
      />
    </>
  );
};

export default DatetimePicker;
